import React from 'react';

// import { useHistory } from 'react-router-dom';

// import Skeleton from 'react-loading-skeleton';
// import { useSelector, useDispatch } from 'react-redux';

// import { Root, ContainerMyCart } from './styles';
// import { StoreState } from '../../store/createStore';

// import { routesEndpoints } from '../../routes/endpoint';
// import { setIsCategory } from '../../store/modules/parameter/actions';

const CheckoutRemake: React.FC = () => {
  // const { user } = useSelector((state: StoreState) => state.auth);

  // const { checkout, summary, remakeLoading } = useSelector(
  //   (state: StoreState) => state.checkout,
  // );

  // const dispatch = useDispatch();
  // const history = useHistory();

  // const onCheckoutAllQtyPlu = useCallback(() => {
  //   dispatch(checkoutAllQtyPlu(user, checkout));
  // }, [dispatch, user, checkout]);

  // useEffect(() => {
  //   if (remakeLoading === false) {
  //     onCheckoutAllQtyPlu();
  //   }
  // }, [remakeLoading, onCheckoutAllQtyPlu]);

  // useEffect(() => {
  //   if (summary?.items) {
  //     history.push(routesEndpoints.SUMMARY);
  //   }
  // }, [summary, history]);

  // useEffect(() => {
  //   dispatch(setIsCategory(false));
  // }, [dispatch]);

  // return (
  //   <Root>
  //     <ContainerMyCart>
  //       <Skeleton
  //         style={{ marginBottom: '16px', marginRight: '16px' }}
  //         duration={1}
  //         width={230}
  //         height={230}
  //       />
  //     </ContainerMyCart>
  //   </Root>
  // );
  return (
    <>
    Desativado
    </>
  )
};

export default CheckoutRemake;
